import { render, staticRenderFns } from "./addDemand.vue?vue&type=template&id=5bb78522&scoped=true&"
import script from "./addDemand.vue?vue&type=script&lang=js&"
export * from "./addDemand.vue?vue&type=script&lang=js&"
import style0 from "./addDemand.vue?vue&type=style&index=0&id=5bb78522&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb78522",
  null
  
)

export default component.exports